module.exports = __webpack_public_path__ + "img/pdf-icon.0d74ab28.svg";